import { env } from "./env";

export const mockFlags = {
  auth: env.VITE_MOCK_AUTH,
  dashboard: env.VITE_MOCK_DASHBOARD,
  metrics: env.VITE_MOCK_METRICS,
  organizations: env.VITE_MOCK_ORGANIZATIONS,
  brokers: env.VITE_MOCK_BROKERS,
  developers: env.VITE_MOCK_DEVELOPERS,
  launchRegistrations: env.VITE_MOCK_LAUNCH_REGISTRATIONS,
  agencyRegistrations: env.VITE_MOCK_AGENCY_REGISTRATIONS,
  plans: env.VITE_MOCK_PLANS,
  legal: env.VITE_MOCK_LEGAL,
  subscriptions: env.VITE_MOCK_SUBSCRIPTIONS,
  payments: env.VITE_MOCK_PAYMENTS,
  withdrawals: env.VITE_MOCK_WITHDRAWALS,
  ledger: env.VITE_MOCK_LEDGER,
  finance: env.VITE_MOCK_FINANCE,
  referrals: env.VITE_MOCK_REFERRALS,
  adminUsers: env.VITE_MOCK_ADMIN_USERS,
  audit: env.VITE_MOCK_AUDIT,
  support: env.VITE_MOCK_SUPPORT,
  settings: env.VITE_MOCK_SETTINGS,
  integrations: env.VITE_MOCK_INTEGRATIONS,
  siteContent: env.VITE_MOCK_SITE_CONTENT,
  notifications: env.VITE_MOCK_NOTIFICATIONS,
  accountInvites: env.VITE_MOCK_ACCOUNT_INVITES,
  affiliates: env.VITE_MOCK_AFFILIATES,
} as const;

export type ModuleName = keyof typeof mockFlags;

export function isMock(mod: ModuleName): boolean {
  return mockFlags[mod];
}

export function listActiveMocks(): ModuleName[] {
  return (Object.keys(mockFlags) as ModuleName[]).filter((m) => mockFlags[m]);
}

export function hasAnyMock(): boolean {
  return listActiveMocks().length > 0;
}
